var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.838193 0.671573C0.603877 0.905888 0.603877 1.28579 0.838193 1.5201L2.81809 3.5L0.838193 5.4799C0.603877 5.71421 0.603877 6.09411 0.838193 6.32843C1.07251 6.56274 1.45241 6.56274 1.68672 6.32843L3.66662 4.34853L5.64652 6.32843C5.88083 6.56274 6.26073 6.56274 6.49505 6.32843C6.72936 6.09411 6.72936 5.71421 6.49505 5.4799L4.51515 3.5L6.49505 1.5201C6.72936 1.28579 6.72936 0.905888 6.49505 0.671573C6.26073 0.437258 5.88083 0.437257 5.64652 0.671573L3.66662 2.65147L1.68672 0.671573C1.45241 0.437258 1.07251 0.437257 0.838193 0.671573Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.7583541dca431e3107da399bf2bd3cb1.svg";
export { ForwardRef as ReactComponent };